<template>
  <Teleport to="body">
    <Modal v-model="show">
      <ModalContent size="xlarge">
        <template #header>
          <Heading level="h2">
            {{ station.stationName }}<template v-if="station.trackName">: {{ station.trackName }}</template>
          </Heading>
        </template>

        <div class="tw-aspect-video tw-w-full">
          <img v-if="activeMonitorUrl" :src="activeMonitorUrl" class="tw-w-full tw-object-cover" />
        </div>

        <template #footer="{ reject }">
          <div class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-between">
            <ValueSwitcher v-model="selectedPreview" :options="previewOptions" />
            <Button color="transparent" outlined @click="reject">Close</Button>
          </div>
        </template>
      </ModalContent>
    </Modal>
  </Teleport>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { Button, Heading, Modal, ModalContent, ValueSwitcher } from '@slideslive/fuse-kit/vue';

import useStation from '@/composables/use_station';

const show = defineModel();

const { station } = defineProps({
  station: { type: Object, required: true },
});

const { t } = useI18n();

const previewOptions = [
  { value: 'multiview', label: t('station_monitor_modal.multiview') },
  { value: 'main_camera', label: t('station_monitor_modal.main_camera') },
  { value: 'wide_camera', label: t('station_monitor_modal.wide_camera') },
  { value: 'slides', label: t('station_monitor_modal.slides') },
  { value: 'input_4', label: t('station_monitor_modal.input_4') },
];

const selectedPreview = ref(previewOptions[0].value);

const { monitorUrl } = useStation({
  station: () => station,
  monitorIdx: selectedPreview,
});

const activeMonitorUrl = computed(() => (show.value ? monitorUrl.value : null));

watch(show, (open) => {
  if (!open) {
    selectedPreview.value = previewOptions[0].value;
  }
});
</script>
